export default "__VITE_ASSET__Bs6n0BcT__"